import dayjs from 'dayjs'

interface Props {
  endTime: dayjs.Dayjs
  onFinish: () => void
}

export default ({ endTime = dayjs().add(10, 'second'), onFinish }: Props) => {
  const endTimeRef = ref(endTime)

  const formatTime = (number: number) => `0${number}`.slice(-2)

  const timeLeft = ref({
    day: 0,
    hour: '00',
    minute: '00',
    second: '00',
    ms: 0
  })

  let intervalId: NodeJS.Timeout | null = null

  const calculateTimeLeft = () => {
    const now = dayjs()
    const diff = endTimeRef.value.diff(now)

    if (diff <= 0) {
      return {
        day: 0,
        hour: '00',
        minute: '00',
        second: '00',
        ms: 0
      }
    }

    return {
      day: endTimeRef.value.diff(now, 'day'),
      hour: formatTime(endTimeRef.value.diff(now, 'hour') % 24),
      minute: formatTime(endTimeRef.value.diff(now, 'minute') % 60),
      second: formatTime(endTimeRef.value.diff(now, 'second') % 60),
      ms: diff
    }
  }

  const runCountDown = () => {
    timeLeft.value = calculateTimeLeft()

    intervalId = setInterval(() => {
      timeLeft.value = calculateTimeLeft()

      if (timeLeft.value.ms <= 0 && intervalId) {
        clearInterval(intervalId)
        onFinish()
      }
    }, 1000)
  }

  onMounted(runCountDown)

  onUnmounted(() => {
    if (intervalId) {
      clearInterval(intervalId)
    }
  })

  watch(endTimeRef, runCountDown)

  const setEndTime = (time: dayjs.Dayjs) => {
    endTimeRef.value = time
  }

  return {
    timeLeft,
    setEndTime
  }
}
